import { immerable } from "immer";
export class ReaderPreferences {
    [immerable] = true;
    backgroundColor;
    columnCount;
    fontFamily;
    fontSize;
    fontWeight;
    hyphens;
    imageFilter;
    language;
    letterSpacing;
    ligatures;
    lineHeight;
    pageMargins = 1.5;
    paragraphIndent;
    paragraphSpacing;
    publisherStyles;
    readingProgression;
    scroll;
    spread;
    textAlign;
    textColor;
    textNormalization;
    theme;
    typeScale;
    verticalText;
    wordSpacing;
}
//# sourceMappingURL=ReaderPreferences.js.map